module.exports = __webpack_public_path__ + "static/prof_footer_2-93b1962b7f7319ec9d98852b145b4e11.jpg";